/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DatasetSchema } from '../models/dataset-schema';
@Injectable({
  providedIn: 'root',
})
class DatasetschemaService extends __BaseService {
  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `DatasetschemaService.DatasetschemaListParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `search`: A search term.
   *
   * - `ordering`: Which field to use when ordering the results.
   *
   * - `offset`: The initial index from which to return the results.
   *
   * - `name`:
   *
   * - `mode`:
   *
   * - `limit`: Number of results to return per page.
   *
   * - `id`:
   *
   * - `description`:
   */
  datasetschemaListResponse(params: DatasetschemaService.DatasetschemaListParams): __Observable<__StrictHttpResponse<{count: number, next?: null | string, previous?: null | string, results: Array<DatasetSchema>}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.type != null) __params = __params.set('type', params.type.toString());
    if (params.search != null) __params = __params.set('search', params.search.toString());
    if (params.ordering != null) __params = __params.set('ordering', params.ordering.toString());
    if (params.offset != null) __params = __params.set('offset', params.offset.toString());
    if (params.name != null) __params = __params.set('name', params.name.toString());
    if (params.mode != null) __params = __params.set('mode', params.mode.toString());
    if (params.limit != null) __params = __params.set('limit', params.limit.toString());
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.description != null) __params = __params.set('description', params.description.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/datasetschema/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{count: number, next?: null | string, previous?: null | string, results: Array<DatasetSchema>}>;
      })
    );
  }
  /**
   * @param params The `DatasetschemaService.DatasetschemaListParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `search`: A search term.
   *
   * - `ordering`: Which field to use when ordering the results.
   *
   * - `offset`: The initial index from which to return the results.
   *
   * - `name`:
   *
   * - `mode`:
   *
   * - `limit`: Number of results to return per page.
   *
   * - `id`:
   *
   * - `description`:
   */
  datasetschemaList(params: DatasetschemaService.DatasetschemaListParams): __Observable<{count: number, next?: null | string, previous?: null | string, results: Array<DatasetSchema>}> {
    return this.datasetschemaListResponse(params).pipe(
      __map(_r => _r.body as {count: number, next?: null | string, previous?: null | string, results: Array<DatasetSchema>})
    );
  }

  /**
   * @param data undefined
   */
  datasetschemaCreateResponse(data: DatasetSchema): __Observable<__StrictHttpResponse<DatasetSchema>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/datasetschema/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DatasetSchema>;
      })
    );
  }
  /**
   * @param data undefined
   */
  datasetschemaCreate(data: DatasetSchema): __Observable<DatasetSchema> {
    return this.datasetschemaCreateResponse(data).pipe(
      __map(_r => _r.body as DatasetSchema)
    );
  }

  /**
   * @param id A unique integer value identifying this dataset schema.
   */
  datasetschemaReadResponse(id: number): __Observable<__StrictHttpResponse<DatasetSchema>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/datasetschema/${id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DatasetSchema>;
      })
    );
  }
  /**
   * @param id A unique integer value identifying this dataset schema.
   */
  datasetschemaRead(id: number): __Observable<DatasetSchema> {
    return this.datasetschemaReadResponse(id).pipe(
      __map(_r => _r.body as DatasetSchema)
    );
  }

  /**
   * @param params The `DatasetschemaService.DatasetschemaUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this dataset schema.
   *
   * - `data`:
   */
  datasetschemaUpdateResponse(params: DatasetschemaService.DatasetschemaUpdateParams): __Observable<__StrictHttpResponse<DatasetSchema>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.data;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/datasetschema/${params.id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DatasetSchema>;
      })
    );
  }
  /**
   * @param params The `DatasetschemaService.DatasetschemaUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this dataset schema.
   *
   * - `data`:
   */
  datasetschemaUpdate(params: DatasetschemaService.DatasetschemaUpdateParams): __Observable<DatasetSchema> {
    return this.datasetschemaUpdateResponse(params).pipe(
      __map(_r => _r.body as DatasetSchema)
    );
  }

  /**
   * @param params The `DatasetschemaService.DatasetschemaPartialUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this dataset schema.
   *
   * - `data`:
   */
  datasetschemaPartialUpdateResponse(params: DatasetschemaService.DatasetschemaPartialUpdateParams): __Observable<__StrictHttpResponse<DatasetSchema>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.data;
    let req = new HttpRequest<any>(
      'PATCH',
      this.rootUrl + `/datasetschema/${params.id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DatasetSchema>;
      })
    );
  }
  /**
   * @param params The `DatasetschemaService.DatasetschemaPartialUpdateParams` containing the following parameters:
   *
   * - `id`: A unique integer value identifying this dataset schema.
   *
   * - `data`:
   */
  datasetschemaPartialUpdate(params: DatasetschemaService.DatasetschemaPartialUpdateParams): __Observable<DatasetSchema> {
    return this.datasetschemaPartialUpdateResponse(params).pipe(
      __map(_r => _r.body as DatasetSchema)
    );
  }

  /**
   * @param id A unique integer value identifying this dataset schema.
   */
  datasetschemaDeleteResponse(id: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/datasetschema/${id}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id A unique integer value identifying this dataset schema.
   */
  datasetschemaDelete(id: number): __Observable<null> {
    return this.datasetschemaDeleteResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module DatasetschemaService {

  /**
   * Parameters for datasetschemaList
   */
  export interface DatasetschemaListParams {
    type?: string;

    /**
     * A search term.
     */
    search?: string;

    /**
     * Which field to use when ordering the results.
     */
    ordering?: string;

    /**
     * The initial index from which to return the results.
     */
    offset?: number;
    name?: string;
    mode?: string;

    /**
     * Number of results to return per page.
     */
    limit?: number;
    id?: number;
    description?: string;
  }

  /**
   * Parameters for datasetschemaUpdate
   */
  export interface DatasetschemaUpdateParams {

    /**
     * A unique integer value identifying this dataset schema.
     */
    id: number;
    data: DatasetSchema;
  }

  /**
   * Parameters for datasetschemaPartialUpdate
   */
  export interface DatasetschemaPartialUpdateParams {

    /**
     * A unique integer value identifying this dataset schema.
     */
    id: number;
    data: DatasetSchema;
  }
}

export { DatasetschemaService }
